import React from 'react';

import styles from './FullName.module.css';
import Input from '../../components/FormField/Input';

function Name(props) {
    const { firstNameField, lastNameField } = props;

    return (
        <div className={styles.Name}>
            <div className={`${styles.firstName} fs-exclude`}>
                <Input
                    placeholder="First name"
                    field={firstNameField}
                    maxLength={100}
                />
            </div>

            <div className={`${styles.lastName} fs-exclude`}>
                <Input
                    placeholder="Last name"
                    field={lastNameField}
                    maxLength={100}
                />
            </div>
        </div>
    );
}

export default Name;
